function FBInit() {
	(function(d, s, id) {
	    "use strict";

		    var js;
	    var fjs = d.getElementsByTagName(s)[0];
	    if (d.getElementById(id)) {
	        return;
	    }
	    js = d.createElement(s); js.id = id;
	    js.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.7";
	    fjs.parentNode.insertBefore(js, fjs);
	}(document, "script", "facebook-jssdk"));
};
